var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRealisation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2669 29.9333C23.6307 29.9333 29.6003 23.9637 29.6003 16.5999C29.6003 9.23614 23.6307 3.2666 16.2669 3.2666C8.90313 3.2666 2.93359 9.23614 2.93359 16.5999C2.93359 23.9637 8.90313 29.9333 16.2669 29.9333Z",
    stroke: "#155DFC",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2656 24.5996C20.6839 24.5996 24.2656 21.0179 24.2656 16.5996C24.2656 12.1813 20.6839 8.59961 16.2656 8.59961C11.8473 8.59961 8.26562 12.1813 8.26562 16.5996C8.26562 21.0179 11.8473 24.5996 16.2656 24.5996Z",
    stroke: "#155DFC",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2643 19.266C17.7371 19.266 18.931 18.072 18.931 16.5993C18.931 15.1265 17.7371 13.9326 16.2643 13.9326C14.7916 13.9326 13.5977 15.1265 13.5977 16.5993C13.5977 18.072 14.7916 19.266 16.2643 19.266Z",
    stroke: "#155DFC",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealisation);
export default __webpack_public_path__ + "static/media/realisation.87f114ccacab1bc100a4958337ed870b.svg";
export { ForwardRef as ReactComponent };